import { render, staticRenderFns } from "./friendRecall.vue?vue&type=template&id=ea73dfa0&scoped=true&"
import script from "./friendRecall.vue?vue&type=script&lang=js&"
export * from "./friendRecall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea73dfa0",
  null
  
)

export default component.exports